import { type FC } from "react";
import { Button, ButtonGroup, Card, CardContent, Typography } from "@mui/material";
import { type IntlShape, useIntl } from "react-intl";

const getNavSections = (intl: IntlShape) => [
	{ id: "developer-simulators", label: intl.formatMessage({ id: "Simulators", defaultMessage: "Simulators" }) },
	{ id: "developer-user-details", label: intl.formatMessage({ id: "User Details", defaultMessage: "User Details" }) },
	{
		id: "developer-token-information",
		label: intl.formatMessage({ id: "Token Information", defaultMessage: "Token Information" }),
	},
	{
		id: "developer-feature-flags",
		label: intl.formatMessage({ id: "Feature Flags", defaultMessage: "Feature Flags" }),
	},
	{
		id: "developer-legacy-feature-flags",
		label: intl.formatMessage({ id: "Legacy Feature Flags", defaultMessage: "Legacy Feature Flags" }),
	},
	{ id: "developer-permissions", label: intl.formatMessage({ id: "Permissions", defaultMessage: "Permissions" }) },
];

const scrollToSection = (id: string) => {
	const container = document.getElementById("developer-page");
	const element = document.getElementById(id);

	if (!element || !container) {
		return;
	}

	const elementPosition = element.getBoundingClientRect().top;
	const offsetPosition = elementPosition + window.scrollY - 80;

	container.scrollTo({
		top: offsetPosition,
		behavior: "smooth",
	});
};

export const ToolsPageNavCard: FC = () => {
	const intl = useIntl();

	return (
		<Card>
			<CardContent sx={{ p: 2, "&:last-child": { pb: 2 } }}>
				<ButtonGroup fullWidth variant="outlined">
					{getNavSections(intl).map(({ id, label }) => (
						<Button key={id} size="small" onClick={() => scrollToSection(id)}>
							<Typography noWrap variant="button">
								{label}
							</Typography>
						</Button>
					))}
				</ButtonGroup>
			</CardContent>
		</Card>
	);
};
